export function startTokenMonitor(disableSessionManagement = false) {
    if (sessionStorage.getItem("login") === "true") {
        return setInterval(() => {
            // Skip session monitoring if disabled via client config
            if (disableSessionManagement) {
                return;
            }
            const activityExpiry = new Date(sessionStorage.getItem("activityExpiryTime"));
            const now = Date.now();
            // Idle timeout logout
            if (now >= activityExpiry) {
                sessionStorage.setItem("sessionExpired", true)
                window.location.href = "/logout";
                return;
            }

            // Backend token will be refreshed by axios interceptor automatically
            // so we don't need to handle here

        }, 3000); // every 3 seconds
    } else {
        return null;
    }
}
